// src/sagas/userSagas.js
import { put, takeLatest, call } from "redux-saga/effects";
import { BASE_BACKEND_URL } from "../constant";
function* fetchUsers() {
  try {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      throw new Error("No access token found in localStorage");
    }
    const response = yield call(fetch, `${BASE_BACKEND_URL}/user/credentials/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = yield response.json();
    yield put({ type: "FETCH_USERS_SUCCESS", payload: data });
  } catch (error) {
    yield put({ type: "FETCH_USERS_FAIL", payload: error.message });
  }
}

function* addUser(action) {
  try {
    const response = yield call(
      fetch,
      `${BASE_BACKEND_URL}/user/credentials/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(action.payload),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    yield response.json();
    yield put({ type: "FETCH_USERS_REQUEST" }); // Trigger fetching users again
  } catch (error) {
    yield put({ type: "ADD_USER_FAIL", payload: error.message });
  }
}

function* deleteUser(action) {
  try {
    const response = yield call(
      fetch,
      `${BASE_BACKEND_URL}/user/credentials/`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ id: action.payload }),
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    yield put({ type: "FETCH_USERS_REQUEST" }); // Trigger fetching users again
  } catch (error) {
    yield put({ type: "DELETE_USER_FAIL", payload: error.message });
  }
}

export function* watchUserActions() {
  yield takeLatest("FETCH_USERS_REQUEST", fetchUsers);
  yield takeLatest("ADD_USER_REQUEST", addUser);
  yield takeLatest("DELETE_USER_REQUEST", deleteUser);
}
